import React from 'react';
export function ZoomInIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M9 6v3H6v2h3v3h2v-3h3V9h-3V6H9z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2a8 8 0 105.118 14.148l.313.394c.988 1.247 1.482 1.871 4.569 4.958l1.5-1.5c-3.438-3.438-4.262-4.11-5.345-4.89A8 8 0 0010 2zm-6 8a6 6 0 1112 0 6 6 0 01-12 0z"
  }));
}